"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { usePopoverContext } from '@ark-ui/react/popover';
import { useFloating, autoUpdate, offset, shift, autoPlacement, size } from '@floating-ui/react';

const GUTTER = 10;
const VIEWPORT_PADDING = 8;
const DropdownPositioner = ({ children }) => {
  const context = usePopoverContext();
  const anchorPops = context.getAnchorProps();
  const { refs, floatingStyles } = useFloating({
    whileElementsMounted: autoUpdate,
    elements: {
      reference: anchorPops.id ? document.getElementById(anchorPops.id) : void 0
    },
    middleware: [
      offset({ mainAxis: GUTTER }),
      shift({
        padding: GUTTER * 2
      }),
      autoPlacement({
        allowedPlacements: ["bottom-start", "top-start"],
        crossAxis: true,
        boundary: "clippingAncestors",
        padding: GUTTER / 2
      }),
      size({
        padding: VIEWPORT_PADDING,
        apply({ elements, availableHeight, availableWidth }) {
          const floating = elements.floating;
          availableWidth = Math.floor(availableWidth);
          availableHeight = Math.floor(availableHeight);
          floating.style.setProperty("--available-width", `${availableWidth}px`);
          floating.style.setProperty("--available-height", `${availableHeight}px`);
        }
      })
    ]
  });
  return /* @__PURE__ */ jsx("div", { ref: refs.setFloating, style: floatingStyles, className: "z-popover isolate", children });
};

export { DropdownPositioner };
